import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/shared/services/loader.service';
import { TokenService } from 'src/shared/services/token.service';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { UserNotificationService } from '../shared/services/user.notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  title = 'Volga';
  isLoading$ = this.loaderService.isLoading$;

  constructor(
    private loaderService: LoaderService,
    private tokenService:TokenService, private cdr: ChangeDetectorRef, private swUpdate: SwUpdate, private userNotificationService: UserNotificationService
  ) {}

  ngOnInit(): void {
    const sessionActive = sessionStorage.getItem('sessionActive');

    // Validar nuevas actualizaciones del service worker
    if (this.swUpdate.isEnabled && location.hostname !== 'localhost') {
      // Verifica actualizaciones al iniciar
      this.swUpdate.checkForUpdate();

      // Verifica manualmente si hay una nueva versión cuando el usuario vuelve a enfocar la pestaña o ventana
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.swUpdate.checkForUpdate();
        }
      });

      // Verifica manualmente si hay una nueva versión cuando el usuario interactúa por primera vez después de un despliegue
      const triggerUpdateCheck = () => {
        this.swUpdate.checkForUpdate();
        document.removeEventListener('click', triggerUpdateCheck);
      };
      document.addEventListener('click', triggerUpdateCheck);

      // Suscribirse a las actualizaciones del service worker
      this.swUpdate.versionUpdates.subscribe((event:VersionEvent) => {
        if(event.type === 'VERSION_READY') {
          this.swUpdate.activateUpdate().then(() => {
            this.userNotificationService.showSuccess('ALERTS.NEW-VERSION-AVAILABLE');
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          })
        }
        if (event.type === 'VERSION_INSTALLATION_FAILED') {
          console.error('Fallo al activar la actualización automática');
          this.userNotificationService.showWarning('ALERTS.NEW-VERSION-UPDATE-MANUALLY');
        }
      });

      this.swUpdate.unrecoverable.subscribe(event => {
        console.error('Service Worker no recuperable:', event.reason);
        window.location.reload();
      });
    }

    if (!sessionActive) {
      this.tokenService.logout(false);
    } else {
      this.tokenService.checkTokenOnAppStart();
    }
  }
}
